<script setup>

import JFormPassword from "@/component/form/FormPassword.vue";

/**
 * 參數 - 外部 - 提交
 */
const emit = defineEmits(["update", "submit"])

/**
 * 傳入 - 參數
 */
const props = defineProps({
    field: { type: Object, required: true },
    placeholder: { type: String, required: true }
  })

</script>

<template>
  <div class="s5 w-100">
    <j-form-password
        name="passwd"
        @keyup="emit(`update`)"
        @keyup.stop.prevent.enter="emit(`submit`)"
        :bottom="0"
        :source="props.field"
        :holder="props.placeholder" />
  </div>
</template>

<style scoped lang="scss">
.s5 {
  position: relative;
}
</style>